import { render, staticRenderFns } from "./SelectModalType.vue?vue&type=template&id=56632026&scoped=true"
import script from "./SelectModalType.vue?vue&type=script&lang=js"
export * from "./SelectModalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56632026",
  null
  
)

export default component.exports